import React, {useState} from 'react';

const ErrorPage = ({sfalma: errorCode}) => {

  const createMessage = code => {
    if(code === 404) {
      return 'Not found';
    }
    return 'Internal server error'
  }

  const [message] = useState(createMessage(errorCode));



  return (
    <div>
      <h1>Error Page</h1>
      <h3>{message}</h3>
    </div>
  )
};

export default ErrorPage;
